/**
 * READ ME.
 *
 * Please use snake-case for all routes and not camelCase.
 *
 * Right: /settings/my-stuff
 *
 * Wrong: /settings/myStuff
 */

export const routes = {
  acceptDocuments: '/accept-documents',
  present: '/',
  presentHome: '/present',
  pageNotFound: '/404',
  redeemGiftCard: '/redeem',
  early: {
    index: '/early',
    lander: '/early/upgrade',
    performanceRoute: '/early/performance',
    detailsRoute: '/early/details',
    investments: '/early/activity/:beneficiaryId',
    ageOfTransferReached: '/early/age-of-transfer-reached/:beneficiaryId',
    ageOfTransferNextSteps: '/early/age-of-transfer-next-steps/:beneficiaryId',
    onboarding: '/early/onboarding/welcome',
    onboardingTour: '/early/onboarding/tour',
    stateSelection: '/early/onboarding/state_selection/:beneficiaryId?',
    beneficiaryDetails: '/early/onboarding/beneficiary_details',
    finishSetupLander: '/early/onboarding/finish-setup/:beneficiaryId',
    ssnInterstitial: '/early/onboarding/ssn_interstitial/:beneficiaryId',
    ssnForm: '/early/onboarding/ssn_form/:beneficiaryId',
    ageOfTransfer: '/early/onboarding/age_of_transfer/:beneficiaryId',
    ageOfTransferFAQ: '/early/age-of-transfer-faq/:beneficiaryId',
    openingEarlyAccount:
      '/early/onboarding/opening_early_account/:beneficiaryId',
    success: '/early/onboarding/success/:beneficiaryId',
    recurring: '/early/recurring/:beneficiaryId',
    recurringPotential: '/early/recurring_potential/:beneficiaryId',
    recurringSuccess: '/early/details/:beneficiaryId/recurring/success',
    investmentDisclosure:
      '/early/recurring_potential/:beneficiaryId/investment_disclosure',
    portfolio: '/early/portfolio/:beneficiaryId',
    potential: '/early/potential/:beneficiaryId',
    details: '/early/details/:beneficiaryId',
    oneTime: '/early/one_time/:beneficiaryId',
    performance: '/early/performance/:beneficiaryId',
    withdraw: '/early/withdraw/:beneficiaryId',
    withdrawInterstitial: '/early/withdraw/interstitial/:beneficiaryId',
    gifts: '/early/gifts/:beneficiaryId',
    fundDetails: '/invest/early/portfolio/:beneficiaryId/fund/:fundName',
    referral: '/early/onboarding/referral/:beneficiaryId',
    settings: '/early/settings/:beneficiaryId',
    ssnUploadComplete:
      '/early/settings/ssn_upload_verification/ssn-upload-complete/:beneficiaryId',
    ssnUploadVerification:
      '/early/settings/ssn_upload_verification/:beneficiaryId',
  },
  earlyCustomPortfolio: {
    index: '/early/custom-portfolio/:beneficiaryId',
    portfolio: '/early/custom-portfolio/:beneficiaryId/portfolio',
    lander: '/early/custom-portfolio/:beneficiaryId/lander',
    aboutRebalancing:
      '/early/custom-portfolio/:beneficiaryId/about-rebalancing',
    builder: '/early/custom-portfolio/:beneficiaryId/builder',
    fundingSuccess: '/early/custom-portfolio/:beneficiaryId/funding-success',
  },
  earn: {
    index: '/earn/found-money',
    foundMoney: '/earn/found-money',
    ledger: '/earn/found-money/ledger',
    interstitial: '/earn/interstitial',
    favorites: '/earn/found-money/favorites',
    categories: '/earn/found-money/categories',
    offerGroup: '/earn/found-money/offer-group/:name',
    offer: '/earn/found-money/:owner/:offer/:id',
    offerTermsAndConditions:
      '/earn/found-money/:owner/:offer/:id/terms-and-conditions',
    upgradeLander: '/earn/found-money/upgrade',
    upgrade: '/earn/upgrade',
  },
  settings: {
    index: '/settings',
    linkedAccounts: '/settings/linked-accounts',
    linkedAccount: '/settings/linked-accounts/:linkedAccountId',
    linkAccountModal: '/settings/linked-accounts/institutions',
    investorPortfolioFlow: '/settings/investor/portfolio',
    notifications: '/settings/notifications',
    documentUploader:
      '/settings/linked-accounts/document-uploader/:documentType',
    mfa: '/settings/mfa',
    mfaManage: '/settings/mfa/manage',
    personal: '/settings/personal',
    trustedContacts: '/settings/personal/trusted-contacts/:id',
    trustedContactsBase: '/settings/personal/trusted-contacts',
    privacy: '/settings/privacy',
    email: '/settings/personal/email',
    phone: '/settings/personal/phone',
    spend: '/settings/spend',
    subscriptionCenter: '/settings/my-subscription',
    subscriptionCenterConfirmAccountClosure:
      '/settings/my-subscription/close-account/confirm',
    subscriptionCenterCloseAccount: '/settings/my-subscription/close-account',
    upgradeLander: '/settings/my-subscription/upgrade-lander',
    tierSelection: '/settings/my-subscription/tier-selection',
    pausedFundingSource: '/settings/paused-funding-source',
    changePassword: '/settings/change-password',
    changePrimaryChecking: '/settings/change-primary-checking',
    changePrimaryCheckingSelect: '/settings/change-primary-checking/select',
    changePrimaryCheckingInstitutions:
      '/settings/change-primary-checking/institutions',
    changePrimaryCheckingManual: '/settings/change-primary-checking/manual',
    changePrimaryCheckingHelp: '/settings/change-primary-checking/help',
    compareTiers: '/settings/compare-tiers',
    chatbot: '/settings/chatbot',
  },
  financialAdvisor: {
    index: '/financial-advisor',
  },
  invest: {
    core: '/invest/core',
    performance: '/invest/core/performance',
    portfolio: '/invest/core/portfolio',
    fundIndex: '/invest/core/portfolio/fund',
    fund: '/invest/core/portfolio/fund/:fundName',
    recentActivity: '/invest/core/recent-activity',
    roundUps: '/invest/core/round-ups',
    roundUpsSettings: '/invest/core/round-ups/settings',
    withdrawSuccess: '/invest/core/withdraw/success',
    withdraw: '/invest/core/withdraw',
    oneTimeDeposit: '/invest/core/one-time',
    oneTimeDepositSuccess: '/invest/core/one-time/success',
    recurring: '/invest/core/recurring',
    recurringSuccess: '/invest/core/recurring/success',
    tips: '/invest/core/tips',
  },
  investingHub: {
    index: '/investing-hub',
    performanceAllTime: '/investing-hub/performance?timeframe=all',
    performance: '/investing-hub/performance',
  },
  bankingHub: {
    index: '/banking-hub',
  },
  spend: {
    index: '/spend',
    activate: '/spend/activate',
    cardActivation: '/ca',
    findATM: '/spend/atm-locator',
    atmFinder: '/spend/atm-finder',
    lockedAcount: '/spend/locked-account',
    identitySubmitted: '/spend/signup/verify/identity/submitted',
    identityUpload: '/spend/signup/verify/identity/upload',
    identityUploadResult:
      '/spend/signup/verify/identity/document-uploader-result',
    smartDeposit: '/spend/smart-deposit',
    smartDepositSelect: '/spend/smart-deposit/select-deposit',
    smartDepositNewDepositSuccess:
      '/spend/smart-deposit/new-deposit-success/:settingId',
    smartDepositDistributed: '/spend/smart-deposit/deposit-distributed',
    verificationRequired: '/spend/signup/verify',
    verifyAddress: '/spend/signup/verify/address',
    verifyIdentity: '/spend/signup/verify/identity',
    recentActivity: '/spend/recent-activity',
    signup: '/spend/signup',
    signupAddress: '/spend/signup/address',
    signupMailingAddress: '/spend/signup/address/mailing',
    signupEditAddress: '/spend/signup/address/edit',
    signupEditMailingAddress: '/spend/signup/address/mailing/edit',
    signupAddressError: '/spend/signup/address/error',
    signupMailingAddressError: '/spend/signup/address/mailing/error',
    signupAddressValidation: '/spend/signup/address/validation',
    signupMailingAddressValidation: '/spend/signup/address/mailing/validation',
    signupSign: '/spend/signup/sign',
    signupOccupation: '/spend/signup/occupation',
    signupSignature: '/spend/signup/signature',
    signupConfirm: '/spend/signup/confirm',
    signupOrderFailure: '/spend/signup/order-failure',
    signupFunding: '/spend/signup/funding',
    signupFundingPaused: '/spend/signup/funding-paused',
    signupRecurringDeposit: '/spend/signup/recurring-deposit',
    signupOneTimeDeposit: '/spend/signup/one-time-deposit',
    signupSuccess: '/spend/signup/success',
    signupTransfer: '/spend/signup/transfer',
    signupUnverified: '/spend/signup/unverified',
    mocSignup: '/moc',
    mocSignupAddress: '/moc/address',
    mocSignupMailingAddress: '/moc/address/mailing',
    mocSignupEditAddress: '/moc/address/edit',
    mocSignupEditMailingAddress: '/moc/address/mailing/edit',
    mocSignupAddressError: '/moc/address/error',
    mocSignupMailingAddressError: '/moc/address/mailing/error',
    mocSignupAddressValidation: '/moc/address/validation',
    mocSignupMailingAddressValidation: '/moc/address/mailing/validation',
    mocSignupOccupation: '/moc/occupation',
    mocSignupSignature: '/moc/signature',
    mocSignupConfirm: '/moc/confirm',
    mocSignupOrderFailure: '/moc/order-failure',
    mocVerify: '/moc/verify',
    mocSignupFunding: '/moc/funding',
    mocSignupFundingPaused: '/moc/funding-paused',
    mocSignupRecurringDeposit: '/moc/recurring-deposit',
    mocSignupOneTimeDeposit: '/moc/one-time-deposit',
    mocSignupSuccess: '/moc/success',
    mocUnverified: '/moc/unverified',
    transactionDetails: '/spend/recent-activity/:transactionId',
    transfer: '/spend/transfer',
    transferOut: '/spend/transfer-out',
    directDeposit: '/spend/direct-deposit',
    directDepositForm: '/spend/direct-deposit-form',
    directDepositPreview: '/spend/direct-deposit-form/preview',
    directDepositEmployerInfoForm: '/spend/direct-deposit-form/form',
    directDepositIncentiveTerms: '/spend/direct-deposit-incentive/terms',
    directDepositSuccess: '/spend/direct-deposit/success',
    mocDirectDeposit: '/spend/direct-deposit/moc',
    recurring: '/spend/recurring',
    reissue: '/spend/reissue',
    reissueForm: '/spend/reissue/form',
    reissueLockCardSuccess: '/spend/reissue/lock-success',
    reissueAddress: '/spend/reissue/address',
    reissueAddressEdit: '/spend/reissue/address/edit',
    reissueAddressValidation: '/spend/reissue/address/validation',
    reissueRequestSuccess: '/spend/reissue/request-success',
    reissuePreviouslySubmitted: '/spend/reissue/submitted',
    reissueSuccess: '/spend/reissue/success',
    sendCheck: '/spend/send-check',
    settings: '/spend/settings',
    settingsAddress: '/spend/settings/address',
  },
  emergencyFund: {
    index: '/emergency-fund',
    activity: '/emergency-fund/activity',
    closed: '/emergency-fund/closed',
    downloadAcorns: '/emergency-fund/download-acorns',
    editGoal: '/emergency-fund/edit-goal',
    locked: '/emergency-fund/locked',
    settings: '/emergency-fund/settings',
    transactionHistory: '/emergency-fund/transaction-history',
    transfer: '/emergency-fund/transfer',
    transferSuccess: '/emergency-fund/transfer/success',
    transferOut: '/emergency-fund/transfer-out',
    transferOutSuccess: '/emergency-fund/transfer-out/success',
    verificationRequired: '/emergency-fund/verify',
  },
  alerts: {
    index: '/alerts',
  },
  documents: {
    index: '/documents',
    documentUploaderIndex: '/document-uploader',
    documentUploader: '/document-uploader/:documentType',
    result: '/document-uploader-result',
    statements: '/documents/core/statements',
    taxReports: '/documents/core/taxreports',
  },
  taxCenter: {
    index: '/settings/tax-center',
  },
  later: {
    index: '/invest/later',
    performance: '/invest/later/performance',
    recentActivity: '/invest/later/recent-activity',
    whatIsAnIra: '/invest/later/what-is-an-ira',
    fund: '/invest/later/portfolio/fund/:fundName',
    oneTime: '/invest/later/one-time',
    recurring: '/invest/later/recurring',
    recurringSuccess: '/invest/later/recurring/success',
    lander: '/invest/later/upgrade',
    withdrawReason: '/invest/later/withdraw/reason',
    withdraw: '/invest/later/withdraw',
  },
  portfolio: {
    invest: '/invest/core/portfolio',
    changePortfolioRisk: '/invest/core/portfolio/changePortfolioRisk',
    portfolioRiskUpdated:
      '/invest/core/portfolio/changePortfolioRisk/portfolioRiskUpdated',
    later: '/invest/later/portfolio',
    early: '/early/portfolio/:beneficiaryId',
    aboutInvestPortfolio: '/invest/core/portfolio/about',
    aboutEtfsPortfolio: '/invest/core/portfolio/about-etf',
    aboutLaterPortfolio: '/invest/later/portfolio/about',
    aboutEarlyPortfolio: '/early/portfolio/about/:beneficiaryId',
    aboutEarlyOnboardingPortfolio: '/early/onboarding/portfolio/about',
    aboutSustainability: '/portfolio/about-esg-portfolios',
    changePortfolioTheme: '/portfolio/changePortfolioTheme',
    esgEducationalTour: '/portfolio/changePortFolioTheme/esgEducationTour',
    investorProfile: '/portfolio/investor-profile',
    crypto: {
      index: '/invest/core/portfolio/crypto',
      lander: '/invest/core/portfolio/crypto/details',
      success: '/invest/core/portfolio/crypto/success',
    },
  },
  customPortfolio: {
    index: '/invest/core/custom-portfolio',
    portfolio: '/invest/core/custom-portfolio/portfolio',
    lander: '/invest/core/custom-portfolio/lander',
    upgrade: '/invest/core/custom-portfolio/upgrade',
    aboutRebalancing: '/invest/core/custom-portfolio/about-rebalancing',
    howItWorks: '/invest/core/custom-portfolio/how-it-works',
    howItWorksTour: '/invest/core/custom-portfolio/how-it-works-tour',
    builder: '/invest/core/custom-portfolio/builder',
    search: '/invest/core/custom-portfolio/search',
    securityDetails:
      '/invest/core/custom-portfolio/security-details/:securitySymbol',
    success: '/invest/core/custom-portfolio/success',
  },
  moneyHub: {
    index: '/money-hub',
  },
  moneyManager: {
    index: '/money-manager',
  },
  grow: {
    index: '/grow',
    topic: '/grow/topic',
    faq: '/grow/faq',
  },
  publishing: {
    recap: {
      custodian: {
        base: '/early/quarterly-recap',
        main: '/early/quarterly-recap/:beneficiaryId',
        article: '/early/quarterly-recap/:beneficiaryId/article/:section',
      },
      public: {
        main: '/recap/beneficiary/:publicToken',
        article: '/recap/article/:section',
      },
    },
    setup: '/early/quarterly-recap/setup/:beneficiaryId',
    shareSettings: '/early/quarterly-recap/share-settings/:beneficiaryId',
    upgrade: '/early/quarterly-recap/upgrade/:beneficiaryId',
  },
  benefitsHub: {
    index: '/benefits-hub',
    upgradeLander: '/benefits-hub/:benefit/upgrade',
    benefitDetails: '/benefits-hub/:benefit',
    benefitDetailsContactSupport: '/benefits-hub/:benefit/contact-support',
    goHenry: '/benefits-hub/gohenry',
    earlyCard: '/benefits-hub/early-card',
    taxFilingInvestRefund: {
      lander: '/benefits-hub/tax-filing/invest-refund/:refundId',
      oneTime: '/benefits-hub/tax-filing/invest-refund/:refundId/one-time',
      oneTimeSuccess:
        '/benefits-hub/tax-filing/invest-refund/:refundId/one-time/success',
    },
  },
  learn: {
    index: '/learn-hub',
  },
  referral: {
    invite: '/invite',
    inviteShare: '/invite/share',
    friendsHistory: '/invite/referral-friends-history',
    myReferrals: '/my-referrals',
    offersIndex: '/invite/referral-offers',
    offersRedirect: '/invite/referral-offers/:campaignId',
    offers: '/invite/referral-offers/:campaignId/:status',
  },
}
